import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { User, Loader2, Save } from "lucide-react";
import { toast } from "sonner";

const FIELDS = ["first_name", "last_name", "phone", "address", "postal_code", "city", "country"];

export default function Profile() {
  const { user, setUser } = useAuth();
  const { t } = useTranslation();
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => { if (user && user !== false) setForm(user.profile || {}); }, [user]);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const { data } = await api.put("/auth/profile", form);
      setUser(data);
      toast.success(t("profile.saved"));
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setSaving(false); }
  };

  return (
    <div className="max-w-2xl mx-auto px-5 py-14 paper-noise min-h-[70vh]">
      <div className="flex items-center gap-3 mb-2">
        <span className="w-11 h-11 rounded-full bg-[#FBEDE9] flex items-center justify-center"><User className="w-5 h-5 text-[#E06D53]" /></span>
        <h1 className="font-serif text-4xl tracking-tighter text-[#2C2A28]">{t("profile.title")}</h1>
      </div>
      <p className="text-[#5C5854] mb-8">{user?.email}</p>

      <form onSubmit={save} className="bg-white rounded-2xl border border-[#E5E0D8] p-8 grid sm:grid-cols-2 gap-5">
        {FIELDS.map((key) => (
          <div key={key} className={key === "address" ? "sm:col-span-2" : ""}>
            <Label className="text-xs uppercase tracking-widest text-[#8C857B]">{t(`profile.${key}`)}</Label>
            <Input value={form[key] || ""} onChange={(e) => setForm({ ...form, [key]: e.target.value })}
                   className="mt-1 rounded-xl focus-visible:ring-[#E06D53]" data-testid={`profile-${key}`} />
          </div>
        ))}
        <div className="sm:col-span-2">
          <Button type="submit" disabled={saving} className="rounded-full h-11 px-8 bg-[#E06D53] hover:bg-[#C95B42] text-white" data-testid="profile-save">
            {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <><Save className="w-4 h-4 mr-2" /> {t("profile.save")}</>}
          </Button>
        </div>
      </form>
    </div>
  );
}
